<div class="main-container">
  <app-warning-flags-list> </app-warning-flags-list>
  <app-tickets-active></app-tickets-active>
  <app-onboarding></app-onboarding>
  <app-transactions-box></app-transactions-box>
  <app-recipients-selector mode="normal"></app-recipients-selector>
</div>